export const getGtag = field => new Promise((resolve) => {
  window.gtag('get', process.env.GA4_MEASUREMENT_ID, field, resolve);
});
